import React, { useCallback, useMemo, useRef, useState } from "react"
import { Toast } from "primereact/toast"
import { deleteFile, getFiles } from "../api/files"
import { deletePhoto, getPhoto, getPhotos } from "../api/photo"
import { apiPrefix, getAuthHeader, saveAuth } from "../api/api"
import { PhotoUpload } from "../PhotoUpload/PhotoUpload"
import { Container, FlexH, FlexV, StButton, StPassword } from "../ui/ui"
import { File, Photo } from "../graphql/schema"
import { PhotoEl } from "../PhotoEl/PhotoEl"
import { FileUploadRes, getAssetsPath } from "../sharedTypes/responseData"
import { FileUpload } from "primereact/fileupload"

const ListItem = ({
  text,
  style,
  onTextClick = () => {},
  onRemove,
}: {
  text: string
  style?: React.CSSProperties
  onTextClick?: () => void
  onRemove: () => void
}) => {
  return (
    <div style={style}>
      <div onClick={onTextClick}>{text}</div>
      <StButton icon="pi pi-times" onClick={onRemove}></StButton>
    </div>
  )
}

export const FilePanel = () => {
  const [auth, setAuth] = useState<string>()
  const toast = useRef<Toast>(null)
  const [fileList, setFileList] = useState<File[]>([])

  const getFilesCb = useCallback(async () => {
    var fileList = await getFiles()
    console.log(fileList)
    setFileList(fileList)
  }, [])

  const [photoList, setPhotoList] = useState<Photo[]>([])
  const getPhotosCb = useCallback(async () => {
    var photoList = await getPhotos({ limit: 100, offset: 0 }, getAuthHeader())
    console.log(photoList)
    setPhotoList(photoList)
  }, [])
  const [selectedPhoto, setSelectedPhoto] = useState<Photo>()
  const selectedPhotoUrl = useMemo(() => {
    if (!selectedPhoto) return
    return `${apiPrefix}/${getAssetsPath(selectedPhoto?.fileId || "")}`
  }, [selectedPhoto])

  const [selectedFile, setSelectedFile] = useState<File>()

  return (
    <FlexH>
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          width: "min-content",
          gap: "1rem",
        }}
      >
        <StPassword
          feedback={false}
          value={auth}
          onChange={(e) => {
            var value = e.target.value
            setAuth(value)
          }}
        />
        <Toast ref={toast} />
        <StButton
          onClick={() => {
            if (auth) {
              saveAuth(auth.toString())
              toast.current!.show({
                severity: "info",
                summary: "Info",
                detail: "Auth set",
              })
              setAuth("")
            }
          }}
        >
          Set auth
        </StButton>
      </Container>

      <Container>
        <div>文件列表</div>
        <FileUpload
          mode="advanced"
          customUpload
          uploadHandler={async (evt) => {
            const file = evt.files[0]
            const fileUploadResponse = await fetch(`${apiPrefix}/upload`, {
              method: "PUT",
              headers: {
                "Content-Type": file.type,
                "X-File-Name": encodeURIComponent(file.name),
                ...getAuthHeader(),
              },
              body: file,
            })

            if (!fileUploadResponse.ok) {
              throw new Error(
                `File upload failed: ${fileUploadResponse.statusText}`
              )
            }

            const uploadResult =
              (await fileUploadResponse.json()) as FileUploadRes
            const fileId = uploadResult.data.id

            if (!fileId) {
              throw new Error("File id not found in the upload response.")
            }
          }}
          chooseLabel="Select File"
        ></FileUpload>
        <StButton onClick={getFilesCb}>获取文件列表</StButton>
        <FlexV>
          {fileList.map((file) => {
            return (
              <ListItem
                key={file.id}
                text={file.filename ?? ""}
                style={{
                  display: "flex",
                  alignItems: "end",
                  width: "100%",
                  justifyContent: "space-between",
                }}
                onTextClick={() => {
                  setSelectedFile(file)
                }}
                onRemove={async () => {
                  if (!file.id) return
                  await deleteFile(file.id, getAuthHeader())
                  await getFilesCb()
                }}
              ></ListItem>
            )
          })}
        </FlexV>
      </Container>

      <FlexH>
        <Container>
          <Container>
            <PhotoUpload
              onUploadSuccess={() => {
                console.log("PhotoUpload success")
              }}
              authorId="Inswhis"
            ></PhotoUpload>
            <StButton
              onClick={async () => {
                if (!selectedPhoto?.slug) return
                if (!selectedPhoto?.fileId) return
                var res = await deletePhoto(selectedPhoto.slug, getAuthHeader())
                console.log(res)
                if (res.success)
                  await deleteFile(selectedPhoto.fileId, getAuthHeader())
              }}
            >
              删除当前照片和文件
            </StButton>
          </Container>
          <Container>
            <div>照片列表</div>
            <StButton onClick={getPhotosCb}>获取图片列表</StButton>
            <FlexV>
              {photoList.map((photo) => {
                return (
                  <ListItem
                    key={photo.slug}
                    text={photo.slug || ""}
                    style={{
                      display: "flex",
                      alignItems: "end",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                    onTextClick={async () => {
                      if (!photo.slug) return
                      const photoInfo = await getPhoto(photo.slug)
                      if (photoInfo) {
                        console.log(photoInfo)
                        setSelectedPhoto(photoInfo)
                      }
                    }}
                    onRemove={async () => {
                      if (!photo.slug) return
                      await deletePhoto(photo.slug, getAuthHeader())
                      await getPhotosCb()
                    }}
                  ></ListItem>
                )
              })}
            </FlexV>
          </Container>
        </Container>
        <PhotoEl
          url={selectedPhotoUrl}
          title={selectedPhoto?.title || ""}
          description={selectedPhoto?.description || ""}
          size="10rem"
        ></PhotoEl>
      </FlexH>
    </FlexH>
  )
}
